import { render } from "./AddSms.vue?vue&type=template&id=f9a49384&scoped=true"
import script from "./AddSms.vue?vue&type=script&lang=js"
export * from "./AddSms.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a49384"]])

export default __exports__